import React from 'react';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import { useTranslations, useStyles, useUserSelectedExams } from "examsbook-react-sdk/custom-hooks";

/**
 * Add exams component.
 */

function AddExams(props) {
    const t = useTranslations();
    const classes = useStyles(styles)();
    const { exams, selectedExams, addExamToSelectedList, saveSelectedExams } = useUserSelectedExams();

    function updateAndContinue() {
        saveSelectedExams();
        props.closeModal();
    }

    return (
        <div className={classes.paper}>
            <div className={classes.examHeader}>
                {selectedExams && selectedExams.length > 0 ?
                    <i className="fa fa-arrow-left" onClick={props.closeModal.bind(this, selectedExams)}/> : null
                }
                <h4>{t('select_exams')}</h4>
                <p>{t('preparing_course')}</p>
            </div>
            <div className="add-exam-list change-with-p">
                <ul>
                    {
                        exams && exams.category && exams.category.length > 0 ? exams.category.map((data, index) => {
                            const list =  data.shortDescription && data.shortDescription.includes(',') ? data.shortDescription.split(',') :  [ data.shortDescription ];                             
                            return (
                                <li className={(selectedExams.length > 0 && selectedExams.indexOf(data._id) > -1) ? 'selected-exam' : ''}
                                    key={index}
                                    onClick={addExamToSelectedList.bind(this, data._id)}>
                                    <Checkbox
                                        checked={selectedExams.length > 0 && selectedExams.indexOf(data._id) > -1}
                                        color="primary"
                                    />

                                    <Button>
                                        <span>{data.name}</span>
                                      {data.shortDescription ? <div
                                            className={classes.listingData + ' ' + (selectedExams.length > 0 && selectedExams.indexOf(data._id) > -1 ? classes.selected : null)}>
                                      {list && list.length > 0 && list.map(i => <p>{i}{' '}</p>)}
                                        </div> : null }
                                    </Button>


                                </li>
                            );
                        }) : <li>{t('no_courses')}</li>

                    }

                </ul>
            </div>
            <div className="button-submit">
                <Button disabled={selectedExams.length === 0} onClick={updateAndContinue}>
                    {t('continue')}
                </Button>
            </div>
        </div>
    );
}

const styles = theme => ({
    paper: {
        position: 'absolute',
        width: '500px !important',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '16px 32px',
        outline: 'none',
        '& .add-exam-list.change-with-p': {
            height: 'calc(100vh - 153px) !important',
            margin: '0 !important',
            padding: '20px 0',
            '& ul li': {
                borderBottom: '1px solid #eee !important',
            }
        },
        '& .button-submit': {
            borderTop: '0 !important',
            '& button': {
                backgroundColor: '#008E76 !important',
                width: '100% !important',
                padding: '10px !important',
                '& span': {
                    justifyContent: 'center !important'
                }
            }
        },
        '@media (max-width: 767px)': {
            width: '100% !important',
            '& .add-exam-list.change-with-p': {
                height: 'auto !important',
                margin: '0 !important',
                padding: '85px 0 70px',
                background: '#fff',
                '& ul': {
                    maxHeight: 'unset !important',
                },
            },
            '& .button-submit': {
                borderTop: '0 !important',
                position: 'fixed',
                zIndex: 9,
                bottom: 0,
                left: 0,
                right: 0,
                width: '100%',
                background: '#fff',
                '& button': {
                    backgroundColor: '#008E76 !important',
                    width: '100% !important',
                    padding: '10px !important',
                    '& span': {
                        justifyContent: 'center !important'
                    }
                }
            }

        },
    },
    examHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '5px 10px',
        flexWrap: 'wrap',
        border: '1px solid #eee',
        '& i': {
          position: 'static',
          color: '#000'
        },
        '& h4': {
            paddingTop: '4px !important',
        },
        '& p': {
            width: '100%',
            paddingLeft: '24px !important',
            border: '0 !important',
        },
        '@media (max-width: 767px)': {
            background: '#2962ff',
            padding: '15px 25px',
            border: 0,
            position: 'fixed',
            zIndex: 9,
            top: 0,
            left: 0,
            right: 0,
            width: '100%',
            '& h4': {
                padding: '0 !important',
                color: '#fff !important'
            },
            '& p': {
                display: 'none'
            },
            '& i': {
                color: '#fff !important',
                position: 'relative !important',
                top: '-1px !important',
                fontSize: 20
            }
        }
    },
    listingData: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: 10,
        marginLeft: -30,
        paddingBottom: 10,
        '& p': {
            padding: '6px 20px !important',
            marginRight: '10px !important',
            marginBottom: '10px !important',
            border: '1px solid #eee !important',
            borderRadius: 30,
            color: '#00BFA5 !important',
            whiteSpace: 'nowrap',
        },
        '@media (max-width: 767px)': {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: 10,
            marginLeft: -30,
            paddingBottom: 10,
            '& p': {
                padding: '6px 20px !important',
                marginRight: '10px !important',
                marginBottom: '10px !important',
                border: '1px solid #eee !important',
                borderRadius: 30,
                color: '#00BFA5 !important'
            },
        }
    },
    selected: {
        '& p': {
            backgroundColor: '#5df2d60d !important'
        },
    }
});

export default AddExams;
